import { Routes } from '@angular/router'
import { ContactComponent } from './components/contact.component'
import { ContactLayoutComponent } from './components/layout/contact-layout.component'
import { MedicareWebsite } from './components/medicare-website/medicare-website.component'
import {  JEWebSite } from './components/external-urls/je-website.component'
export const routes: Routes = [
    {
        path: '',
        component: ContactLayoutComponent,
        children: [
            {
                path: 'ContactUS/:insCo',
                component: ContactComponent,
            },
            {
                path: 'medicare-website',
                component: MedicareWebsite

            },
            {
                path: 'je-website',
                component: JEWebSite

            }
        ]
    }
]
